export default __webpack_public_path__ + "static/media/UserManual_FFA4A2.4aee2276.svg";